export default "__VITE_ASSET__TTEJoi6X__"